module.exports = __webpack_public_path__ + "static/media/slideImgOne.a6472078.svg";